import Reveal from 'reveal.js';

// source: https://revealjs.com/config/
// check if reveal element is on page. If so, start it up
if ($('.reveal').length > 0) {
  Reveal.initialize({
    width: 350,
    height: 450,
    progress: false,
    controlsBackArrows: 'visible',
    controlsLayout: 'edges',
    embedded: true,
    help: false,
    transitionSpeed: 'fast', // default/fast/slow
  });
}
